export default function registerComponents(module) {
  // <integration-row-header />
  module.component('integrationRowHeader', {
    controllerAs: 'vm',
    bindings: {
      account: '=',
      onToggleDetails: '&',
    },
    controller: function ($scope) {
      'ngInject';

      this.$onInit = () => {
        $scope.a = this.account; //shortcut for template
      };

      this.getBroadcastNames = () => {
        return _.pluck(this.account.details, 'name').join(', ');
      };

      this.showOnline = () => {
        return this.shouldBeBroadcasting() && !this.showError();
      };

      this.showOffline = () => {
        return !this.showError() && !this.shouldBeBroadcasting();
      };

      this.showError = () => {
        return (
          this.account.token_is_invalid ||
          (this.account.type === 'youtube' && !this.account.__isYTLiveEnabled__)
        );
      };

      this.shouldBeBroadcasting = () => {
        return this.account.details && this.account.details.length > 0;
      };

      this.isProbablyBroadcastingForReal = () => {
        return (
          _.any(_.pluck(this.account.details, 'transcoder_profile')) ||
          _.any(_.pluck(this.account.details, 'stream_source'), (ss) => ss === 'recording')
        );
      };
    },
    template: `
      <div class="row integration-card-header" ng-click="vm.onToggleDetails(a)">
        <div class="hidden-xs col-sm-1" style="width:90px">
          <span class="integration-badge integration-badge--{{a.type}}">
            <img src="/img/ss-144x144.png" class="icon-image" ng-if="::a.type == 'ss'">
            <i class="fa fa-facebook" ng-if="::a.type == 'facebook'"></i>
            <i class="fa fa-youtube-play" ng-if="::a.type == 'youtube'"></i>
            <i class="fa fa-vimeo" ng-if="::a.type == 'vimeo'"></i>
            <i class="fa-brands fa-x-twitter" ng-if="::a.type == 'twitter'"></i>
            <span ng-if="::a.type == 'rtmp_push'">RTMP Push</span>
            <span ng-if="::a.type == 'sportzcast'">SPORTZ CAST</span>
          </span>
        </div>
        <div class="col-sm-1" style="width:30px">
          <div ng-hide="a.hideStatusDot">
            <i class="fa fa-circle color--online" ng-if="vm.showOnline()"></i>
            <i class="fa fa-circle color--red" ng-if="vm.showError()"></i>
            <i class="fa fa-circle color--grey" ng-if="vm.showOffline()"></i>
          </div>
        </div>
        <div class="hidden-xs col-sm-5 text-left" style="flex:1">
          <p class="overflow-ellipse body-2" style="margin-bottom:0"><strong>{{a.display_name}}</strong></p>
          <p class="overflow-ellipse" ng-if="a.display_subtitle" style="margin-bottom:0"><small>{{a.display_subtitle}}</small></p>
        </div>
        <div class="col-sm-5 text-left" style="flex:1">
          <p class="visible-xs overflow-ellipse body-2" style="margin-bottom:0"><strong>{{a.display_name}}</strong></p>
          <div class="overflow-ellipse">
            <span ng-if="vm.shouldBeBroadcasting()">
              <strong class="color--green" ng-show="vm.isProbablyBroadcastingForReal()">Broadcasting</strong>
              <strong class="color--red" ng-hide="vm.isProbablyBroadcastingForReal()">Not Connected</strong>
              <br><small>{{vm.getBroadcastNames()}}</small>
            </span>
          </div>
        </div>
        <div class="col-sm-1 text-center">
          <i class="fa fa-chevron-{{a.__showDetails?'up':'down'}}"></i>
        </div>
      </div>
    `,
  });

  // <integration-row-details />
  module.component('integrationRowDetails', {
    controllerAs: 'vm',
    bindings: {
      account: '=',
      onDeleteLink: '&',
      onEditRtmp: '&',
      onDeleteRtmp: '&',
      onRelink: '&',
      onEditSportzcast: '&',
    },
    controller: function ($scope, $rootScope) {
      'ngInject';
      this.user = $rootScope.user;

      this.$onInit = () => {
        $scope.a = this.account; //shortcut for template
      };

      this.dateValid = (d) => {
        return d && Date.parse(d) != 0;
      };

      this.vueDashboardRoot = $rootScope.vueDashboardRoot;

      this.userCan = (action, account) => {
        switch (account.type) {
          case 'facebook': // fall-through
          case 'twitter': // fall-through
          case 'vimeo': // fall-through
          case 'youtube':
            return this.user.can(action, account.type + '-user/*');
            break;

          case 'rtmp_push':
            return this.user.can(action, 'static-rtmp-channel/*');
            break;

          default:
            // shrug
            return true;
        }
      };

      this.warningMessage = () => {
        if (this.account.token_is_invalid) {
          return this.account.token_invalid_reason;
        } else if (this.account.type === 'youtube' && !this.account.__isYTLiveEnabled__) {
          return 'YouTube Live permission is not set';
        }
        return null;
      };
    },
    template: `
      <div class="row" style="display:block">
        <div class="col-sm-8">
          <table class="table table-condensed body-3">
            <thead ng-if="vm.warningMessage()">
              <tr><th colspan="2" class="text-xs">ERROR</th></tr>
              <tr><td colspan="2">
                <div class="bg-danger text-danger" style="padding:10px;margin:0px 0 10px;border:1px solid">{{ vm.warningMessage() }}</div>
              </td></tr>
            </thead>
            <tr><th colspan="2" class="text-xs">CONFIGURATION</th></tr>
            <tr ng-if="a.type == 'sportzcast'"><td>Username</td><td>{{a.username}}</td></tr>
            <tr ng-if="a.type != 'rtmp_push' && a.type != 'ss' && a.type != 'sportzcast'"><td>Linked</td><td>{{a.created_at | date}}</td></tr>
            <tr ng-if="vm.dateValid(a.token_last_used_at)"><td>Last Used</td><td>{{a.token_last_used_at | date}}</td></tr>
            <tr ng-if="vm.dateValid(a.token_expires_at)"><td>Expires</td><td>{{a.token_expires_at | date}}</td></tr>

            <tr ng-if="a.type == 'rtmp_push'"><td>Stream URL</td><td>{{a.stream_url}}</td></tr>
            <tr ng-if="a.type == 'rtmp_push'"><td>Stream Key</td><td style="overflow-wrap: anywhere;">{{a.stream_key}}</td></tr>
            <tr ng-if="a.type == 'rtmp_push' && a.username"><td>Username</td><td>{{a.username}}</td></tr>
            <tr ng-if="a.type == 'rtmp_push' && a.password"><td>Password</td><td><i class="fa fa-lock"></i> ••••••••</td></tr>
            <tr ng-if="a.type == 'rtmp_push'"><td>Max Resolution</td><td>{{a.max_resolution == 0 ? 'None (use highest)' : (a.max_resolution+'p')}}</td></tr>
          </table>
          <table ng-if="a.type == 'facebook' && a.pages_managed && a.pages_managed.length" class="table table-condensed body-3">
            <tr><th class="text-xs">PAGES MANAGED</th></tr>
            <tr ng-repeat="p in a.pages_managed">
              <td>
                {{p.name}}
                <a href="https://www.facebook.com/profile.php?id={{p.id}}" target="_blank"><i class="fa fa-external-link"></i></a>
              </td>
            </tr>
          </table>
          <p class="help-block" ng-if="a.type == 'youtube'">
            <i class="fa fa-info-circle"></i>
            BoxCast uses YouTube API Services to create and manage your YouTube Live broadcasts.  By using this integration, you are
            bound to the <a href="https://www.youtube.com/t/terms" target="_blank">YouTube Terms of Service</a>.
          </p>
          <p class="help-block" ng-if="a.type == 'facebook'">
            <i class="fa fa-info-circle"></i>
            BoxCast uses the Facebook Live API to create and manage your Facebook Live broadcasts. Facebook's Platform Policy requires that
            you don't put third-party video ads in your live video (for example, don't include bumpers, pre-roll, mid-roll or post-roll).
            You must also ensure that any pre-recorded content is clearly distinguishable from live content. For more information, see the
            <a href="https://developers.facebook.com/policy/#liveAPI" target="_blank">Live API section of Facebook's Platform Policy</a>.
          </p>
        </div>
        <div class="col-sm-4">
          <p class="text-center" ng-repeat="broadcast in a.details">
            <a class="btn btn-default btn-block" href="{{vm.vueDashboardRoot}}/broadcasts/{{broadcast.id}}" target="_blank">
              View Current Broadcast
            </a>
          </p>
          <p class="text-center" ng-if="a.type == 'rtmp_push'">
            <button type="button" class="btn btn-default btn-block" ng-if="::vm.userCan('update', a)" ng-click="vm.onEditRtmp(a)">
              Edit Settings
            </button>
          </p>
          <p class="text-center" ng-if="a.type == 'facebook' || a.type == 'twitter'  || a.type == 'youtube'">
            <button type="button" class="btn btn-default btn-block" ng-if="::vm.userCan('update', a)" ng-click="vm.onRelink(a)">
              Re-link Integration
            </button>
          </p>
          <p class="text-center" ng-if="a.type == 'rtmp_push'">
            <button type="button" class="btn btn-default btn-block" ng-if="::vm.userCan('delete', a)" ng-click="vm.onDeleteRtmp(a)">
              Delete RTMP Push Channel
            </button>
          </p>
          <p class="text-center" ng-if="a.type != 'rtmp_push' && a.type != 'ss' && a.type != 'sportzcast'">
            <button type="button" class="btn btn-default btn-block" ng-if="::vm.userCan('delete', a)" ng-click="vm.onDeleteLink(a)">
              Delete Link from BoxCast
            </button>
          </p>
          <p class="text-center" ng-if="a.type == 'sportzcast'">
            <button type="button" class="btn btn-default btn-block" ng-if="::vm.userCan('update', a)" ng-click="vm.onEditSportzcast(a)">
              Edit Settings
            </button>
          </p>
        </div>
      </div>
    `,
  });
}



// WEBPACK FOOTER //
// ./app/pages/settings/components.js